export * from './declaration-end.component';
export * from './declaration-end-informations/declaration-end-information.component';
export * from './declaration-end-intervention/declaration-end-intervention.component';
export * from './declaration-end-history/declaration-end-history.component';
export * from './declaration-end-history/declaration-end-history-date/declaration-end-history-date.component';
export * from './declaration-end-history/declaration-end-history-appointment/declaration-end-history-appointment.component';
